export default "__VITE_ASSET__Cl7A_jkD__"